
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/succesverhalen",
      function () {
        return require("private-next-pages/succesverhalen.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/succesverhalen"])
      });
    }
  